import React from "react";
const AnalyserContext = React.createContext({});
export const AnalyserProvider = AnalyserContext.Provider;
export default AnalyserContext;

